// // // Localização: ./src/components/Management/UserModal.js (Versão 3.1.0 - Correção 401 e API)

// // import React, { useState, useEffect } from 'react';
// // // 🛑 IMPORTAR A INSTÂNCIA CONFIGURADA
// // import api from '../../api/api'; 
// // import { useAuth } from '../../context/AuthContext';

// // // Roles disponíveis no sistema (Ajuste conforme o seu banco de dados)
// // const availableRoles = [
// //     'admin', 
// //     'gerente', 
// //     'profissional', 
// //     'cuidador'
// // ];

// // // O onSave NÃO deve receber dados do usuário, mas sim o comando de sucesso para recarregar a lista.
// // const UserModal = ({ isOpen, onClose, onSaveSuccess, editingUser = null }) => { 
// //     // Removendo 'token' de useAuth, pois o 'api' já lida com isso.
// //     const { user } = useAuth(); 
    
// //     // ESTADO: Variáveis e Setters
// //     const [nomeCompleto, setNomeCompleto] = useState('');
// //     const [email, setEmail] = useState('');
// //     const [senha, setSenha] = useState('');
// //     const [role, setRole] = useState(availableRoles[0]); 
// //     const [error, setError] = useState(null);
// //     const [loading, setLoading] = useState(false);
    
// //     const isEditing = !!editingUser;

// //     // Efeito para carregar dados do usuário ao editar
// //     useEffect(() => {
// //         if (isEditing) {
// //             setNomeCompleto(editingUser.nome_completo || editingUser.nome || '');
// //             setEmail(editingUser.email || '');
// //             setRole(editingUser.role || availableRoles[0]);
// //         } else {
// //             setNomeCompleto('');
// //             setEmail('');
// //             setSenha('');
// //             setRole(availableRoles[0]);
// //         }
// //         setError(null);
// //         setLoading(false);
// //         // O token não é mais lido do AuthContext aqui, pois o 'api' usa o interceptor.
// //     }, [editingUser, isEditing, isOpen]);


// //     // ----------------------------------------------------
// //     // FUNÇÃO DE SALVAMENTO (CRIAÇÃO ou EDIÇÃO)
// //     // ----------------------------------------------------
// //     const handleSubmit = async (e) => {
// //         e.preventDefault();
// //         setError(null);
// //         setLoading(true);

// //         if (!nomeCompleto || !email || (!isEditing && !senha) || !role) {
// //             setError('Por favor, preencha todos os campos obrigatórios (e a senha na criação).');
// //             setLoading(false);
// //             return;
// //         }

// //         // 🛑 CAMINHO RELATIVO, SEM BASE URL
// //         const endpoint = isEditing ? `/usuarios/${editingUser.id}` : '/usuarios';
// //         const method = isEditing ? 'put' : 'post';
        
// //         const userData = {
// //             nome_completo: nomeCompleto,
// //             email: email,
// //             role: role,
// //             ...(senha && { senha: senha }), 
// //         };

// //         try {
// //             // 🛑 USANDO A INSTÂNCIA 'api'
// //             await api({
// //                 method: method,
// //                 url: endpoint, // Caminho relativo
// //                 data: userData,
// //                 // Removido o headers.Authorization, pois o interceptor faz isso
// //             });

// //             // 🛑 SUCESSO: Chama a função para recarregar a lista
// //             onSaveSuccess(); 
// //             onClose(); 
            
// //         } catch (err) {
// //             console.error(`Erro ao ${isEditing ? 'editar' : 'criar'} usuário:`, err.response || err);
// //             const msg = err.response?.data?.message || `Falha ao ${isEditing ? 'editar' : 'criar'} o usuário.`;
// //             setError(msg);
// //         } finally {
// //             setLoading(false);
// //         }
// //     };

// //     if (!isOpen) return null;

// //     // ----------------------------------------------------
// //     // JSX do Modal (PERMANECE O MESMO)
// //     // ----------------------------------------------------
// //     return (
// //         <div className="fixed inset-0 bg-gray-600 bg-opacity-75 flex items-center justify-center z-50 p-4">
// //             <div className="bg-white rounded-lg shadow-xl w-full max-w-lg">
// //                 <header className="p-5 border-b flex justify-between items-center">
// //                     <h3 className="text-xl font-semibold text-gray-800">
// //                         {isEditing ? 'Editar Usuário' : 'Novo Usuário'}
// //                     </h3>
// //                     <button onClick={onClose} className="text-gray-400 hover:text-gray-600">
// //                         <i className="bi bi-x-lg text-lg"></i>
// //                     </button>
// //                 </header>

// //                 <form onSubmit={handleSubmit} className="p-5 space-y-4">
                    
// //                     {error && (
// //                         <div className="p-3 text-sm text-red-700 bg-red-100 rounded-lg">{error}</div>
// //                     )}
                    
// //                     <div>
// //                         <label htmlFor="nome" className="block text-sm font-medium text-gray-700">Nome Completo</label>
// //                         <input
// //                             id="nome"
// //                             type="text"
// //                             required
// //                             className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2"
// //                             value={nomeCompleto}
// //                             onChange={(e) => setNomeCompleto(e.target.value)}
// //                         />
// //                     </div>
                    
// //                     <div>
// //                         <label htmlFor="email" className="block text-sm font-medium text-gray-700">Email</label>
// //                         <input
// //                             id="email"
// //                             type="email"
// //                             required
// //                             className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2"
// //                             value={email}
// //                             onChange={(e) => setEmail(e.target.value)}
// //                             disabled={isEditing} 
// //                         />
// //                     </div>

// //                     <div>
// //                         <label htmlFor="role" className="block text-sm font-medium text-gray-700">Perfil (Role)</label>
// //                         <select
// //                             id="role"
// //                             required
// //                             className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2"
// //                             value={role}
// //                             onChange={(e) => setRole(e.target.value)}
// //                         >
// //                             {availableRoles.map((r) => (
// //                                 <option key={r} value={r}>{r.toUpperCase()}</option>
// //                             ))}
// //                         </select>
// //                     </div>

// //                     <div>
// //                         <label htmlFor="senha" className="block text-sm font-medium text-gray-700">
// //                             Senha {isEditing ? '(Deixe vazio para manter a atual)' : ''}
// //                         </label>
// //                         <input
// //                             id="senha"
// //                             type="password"
// //                             required={!isEditing}
// //                             className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2"
// //                             value={senha}
// //                             onChange={(e) => setSenha(e.target.value)}
// //                         />
// //                     </div>

// //                     <footer className="pt-4 flex justify-end space-x-3">
// //                         <button
// //                             type="button"
// //                             onClick={onClose}
// //                             className="py-2 px-4 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 hover:bg-gray-50 transition-colors"
// //                         >
// //                             Cancelar
// //                         </button>
// //                         <button
// //                             type="submit"
// //                             disabled={loading}
// //                             className={`py-2 px-4 rounded-md shadow-sm text-sm font-medium text-white transition-colors ${loading ? 'bg-teal-400' : 'bg-teal-600 hover:bg-teal-700'}`}
// //                         >
// //                             {loading ? 'Salvando...' : (isEditing ? 'Salvar Alterações' : 'Criar Usuário')}
// //                         </button>
// //                     </footer>
// //                 </form>
// //             </div>
// //         </div>
// //     );
// // };

// // export default UserModal;

// // Localização: ./src/components/Management/UserModal.js (Versão 3.2.0 - Adicionado Campo telefone)

// import React, { useState, useEffect } from 'react';
// import api from '../../api/api'; 
// import { useAuth } from '../../context/AuthContext';

// const availableRoles = [
//     'admin', 
//     'gerente', 
//     'profissional', 
//     'cuidador'
// ];



// const UserModal = ({ isOpen, onClose, onSaveSuccess, editingUser = null }) => { 
//     const { user } = useAuth(); 
    
//     // ESTADO: Variáveis e Setters
//     const [nomeCompleto, setNomeCompleto] = useState('');
//     const [email, setEmail] = useState('');
//     const [senha, setSenha] = useState('');
//     const [role, setRole] = useState(availableRoles[0]); 
//     const [telefone, setTelefone] = useState(''); // 🛑 NOVO ESTADO
//     const [error, setError] = useState(null);
//     const [loading, setLoading] = useState(false);
    
//     const isEditing = !!editingUser;

//     useEffect(() => {
//         if (isEditing) {
//             setNomeCompleto(editingUser.nome_completo || editingUser.nome || '');
//             setEmail(editingUser.email || '');
//             setRole(editingUser.role || availableRoles[0]);
//             setTelefone(editingUser.telefone || ''); // 🛑 CARREGAR DADO
//         } else {
//             setNomeCompleto('');
//             setEmail('');
//             setSenha('');
//             setRole(availableRoles[0]);
//             setTelefone(''); // 🛑 LIMPAR DADO
//         }
//         setError(null);
//         setLoading(false);
//     }, [editingUser, isEditing, isOpen]);


//     const handleSubmit = async (e) => {
//         e.preventDefault();
//         setError(null);
//         setLoading(true);

//         // A validação do telefone é opcional
//         if (!nomeCompleto || !email || (!isEditing && !senha) || !role) {
//             setError('Por favor, preencha todos os campos obrigatórios (e a senha na criação).');
//             setLoading(false);
//             return;
//         }

//         const endpoint = isEditing ? `/usuarios/${editingUser.id}` : '/usuarios';
//         const method = isEditing ? 'put' : 'post';
        
//         const userData = {
//             nome_completo: nomeCompleto,
//             email: email,
//             role: role,
//             telefone: telefone || null, // 🛑 ENVIAR DADO
//             ...(senha && { senha: senha }), 
//         };

//         try {
//             await api({
//                 method: method,
//                 url: endpoint, 
//                 data: userData,
//             });

//             onSaveSuccess(); 
//             onClose(); 
            
//         } catch (err) {
//             console.error(`Erro ao ${isEditing ? 'editar' : 'criar'} usuário:`, err.response || err);
//             const msg = err.response?.data?.message || `Falha ao ${isEditing ? 'editar' : 'criar'} o usuário.`;
//             setError(msg);
//         } finally {
//             setLoading(false);
//         }
//     };

//     if (!isOpen) return null;

//     return (
//         <div className="fixed inset-0 bg-gray-600 bg-opacity-75 flex items-center justify-center z-50 p-4">
//             <div className="bg-white rounded-lg shadow-xl w-full max-w-lg">
//                 <header className="p-5 border-b flex justify-between items-center">
//                     <h3 className="text-xl font-semibold text-gray-800">
//                         {isEditing ? 'Editar Usuário' : 'Novo Usuário'}
//                     </h3>
//                     <button onClick={onClose} className="text-gray-400 hover:text-gray-600">
//                         <i className="bi bi-x-lg text-lg"></i>
//                     </button>
//                 </header>

//                 <form onSubmit={handleSubmit} className="p-5 space-y-4">
                    
//                     {error && (
//                         <div className="p-3 text-sm text-red-700 bg-red-100 rounded-lg">{error}</div>
//                     )}
                    
//                     {/* NOME COMPLETO */}
//                     <div>
//                         <label htmlFor="nome" className="block text-sm font-medium text-gray-700">Nome Completo</label>
//                         <input
//                             id="nome"
//                             type="text"
//                             required
//                             className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2"
//                             value={nomeCompleto}
//                             onChange={(e) => setNomeCompleto(e.target.value)}
//                         />
//                     </div>
                    
//                     {/* EMAIL */}
//                     <div>
//                         <label htmlFor="email" className="block text-sm font-medium text-gray-700">Email</label>
//                         <input
//                             id="email"
//                             type="email"
//                             required
//                             className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2"
//                             value={email}
//                             onChange={(e) => setEmail(e.target.value)}
//                             disabled={isEditing} 
//                         />
//                     </div>
                    
//                     {/* 🛑 TELEFONE */}
//                     <div>
//                         <label htmlFor="telefone" className="block text-sm font-medium text-gray-700">Telefone</label>
//                         <input
//                             id="telefone"
//                             type="text"
//                             className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2"
//                             value={telefone}
//                             onChange={(e) => setTelefone(e.target.value)}
//                             placeholder="(xx) xxxxx-xxxx"
//                         />
//                     </div>


//                     {/* PERFIL (ROLE) */}
//                     <div>
//                         <label htmlFor="role" className="block text-sm font-medium text-gray-700">Perfil (Role)</label>
//                         <select
//                             id="role"
//                             required
//                             className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2"
//                             value={role}
//                             onChange={(e) => setRole(e.target.value)}
//                         >
//                             {availableRoles.map((r) => (
//                                 <option key={r} value={r}>{r.toUpperCase()}</option>
//                             ))}
//                         </select>
//                     </div>

//                     {/* SENHA */}
//                     <div>
//                         <label htmlFor="senha" className="block text-sm font-medium text-gray-700">
//                             Senha {isEditing ? '(Deixe vazio para manter a atual)' : ''}
//                         </label>
//                         <input
//                             id="senha"
//                             type="password"
//                             required={!isEditing}
//                             className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2"
//                             value={senha}
//                             onChange={(e) => setSenha(e.target.value)}
//                         />
//                     </div>

//                     <footer className="pt-4 flex justify-end space-x-3">
//                         <button
//                             type="button"
//                             onClick={onClose}
//                             className="py-2 px-4 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 hover:bg-gray-50 transition-colors"
//                         >
//                             Cancelar
//                         </button>
//                         <button
//                             type="submit"
//                             disabled={loading}
//                             className={`py-2 px-4 rounded-md shadow-sm text-sm font-medium text-white transition-colors ${loading ? 'bg-teal-400' : 'bg-teal-600 hover:bg-teal-700'}`}
//                         >
//                             {loading ? 'Salvando...' : (isEditing ? 'Salvar Alterações' : 'Criar Usuário')}
//                         </button>
//                     </footer>
//                 </form>
//             </div>
//         </div>
//     );
// };

// export default UserModal;

// // Localização: ./src/components/Management/UserModal.js (Versão 3.3.0 - adição da injeção no beckend permissões)

import React, { useState, useEffect } from 'react';
import api from '../../api/api'; 
import { useAuth } from '../../context/AuthContext';

const availableRoles = [
    'admin',
    'proprietario',
    'gerente', 
    'cuidador', 
    'enfermeiro',
    'medico',
    'fisioterapeuta',
    'familiar'
];

const UserModal = ({ isOpen, onClose, onSaveSuccess, editingUser = null }) => { 
    // 🛑 PONTO CHAVE: Captura o usuário logado (Proprietário) para obter o organizacao_id
    const { user } = useAuth(); 
    
    // ESTADO: Variáveis e Setters
    const [nomeCompleto, setNomeCompleto] = useState('');
    const [email, setEmail] = useState('');
    const [senha, setSenha] = useState('');
    const [role, setRole] = useState(availableRoles[0]); 
    const [telefone, setTelefone] = useState('');
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(false);
    
    // Permite criação e edição de usuários
    const isEditing = !!editingUser;

    useEffect(() => {
        if (isEditing) {
            setNomeCompleto(editingUser.nome_completo || editingUser.nome || '');
            setEmail(editingUser.email || '');
            setRole(editingUser.role || availableRoles[0]);
            setTelefone(editingUser.telefone || '');
        } else {
            setNomeCompleto('');
            setEmail('');
            setSenha('');
            setRole(availableRoles[0]);
            setTelefone('');
        }
        setError(null);
        setLoading(false);
    }, [editingUser, isEditing, isOpen]);


    const handleSubmit = async (e) => {
        e.preventDefault();
        setError(null);
        setLoading(true);

        // Validações
        if (!nomeCompleto || !email || !role) {
            setError('Por favor, preencha todos os campos obrigatórios.');
            setLoading(false);
            return;
        }

        // Senha obrigatória apenas na criação
        if (!isEditing && !senha) {
            setError('A senha é obrigatória para criar um novo usuário.');
            setLoading(false);
            return;
        }

        // Validar formato de email
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(email)) {
            setError('Por favor, insira um email válido.');
            setLoading(false);
            return;
        }

        // Validar senha na criação (mínimo 8 caracteres)
        if (!isEditing && senha.length < 8) {
            setError('A senha deve ter no mínimo 8 caracteres.');
            setLoading(false);
            return;
        }

        const endpoint = isEditing ? `/usuarios/${editingUser.id}` : '/usuarios';
        const method = isEditing ? 'put' : 'post';
        
        const userData = {
            nome_completo: nomeCompleto.trim(),
            email: email.toLowerCase().trim(),
            role: role,
            telefone: telefone || null,
            ...(senha && { senha: senha }), 
        };

        try {
            await api({
                method: method,
                url: endpoint, 
                data: userData,
            });

            onSaveSuccess(); 
            onClose(); 
            
        } catch (err) {
            console.error(`Erro ao ${isEditing ? 'editar' : 'criar'} usuário:`, err.response || err);
            const msg = err.response?.data?.message || `Falha ao ${isEditing ? 'editar' : 'criar'} o usuário.`;
            setError(msg);
        } finally {
            setLoading(false);
        }
    };

    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 bg-gray-600 bg-opacity-75 flex items-center justify-center z-50 p-4">
            <div className="bg-white rounded-lg shadow-xl w-full max-w-lg">
                <header className="p-5 border-b flex justify-between items-center">
                    <h3 className="text-xl font-semibold text-gray-800">
                        {isEditing ? 'Editar Usuário' : 'Criar Novo Usuário'}
                    </h3>
                    <button onClick={onClose} className="text-gray-400 hover:text-gray-600">
                        <i className="bi bi-x-lg text-lg"></i>
                    </button>
                </header>

                <form onSubmit={handleSubmit} className="p-5 space-y-4">
                    
                    {error && (
                        <div className="p-3 text-sm text-red-700 bg-red-100 rounded-lg">{error}</div>
                    )}
                    
                    {/* NOME COMPLETO */}
                    <div>
                        <label htmlFor="nome" className="block text-sm font-medium text-gray-700">Nome Completo</label>
                        <input
                            id="nome"
                            type="text"
                            required
                            className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2"
                            value={nomeCompleto}
                            onChange={(e) => setNomeCompleto(e.target.value)}
                        />
                    </div>
                    
                    {/* EMAIL */}
                    <div>
                        <label htmlFor="email" className="block text-sm font-medium text-gray-700">Email</label>
                        <input
                            id="email"
                            type="email"
                            required
                            className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            disabled={isEditing}
                            placeholder="usuario@exemplo.com"
                        />
                    </div>
                    
                    {/* TELEFONE */}
                    <div>
                        <label htmlFor="telefone" className="block text-sm font-medium text-gray-700">Telefone</label>
                        <input
                            id="telefone"
                            type="text"
                            className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2"
                            value={telefone}
                            onChange={(e) => setTelefone(e.target.value)}
                            placeholder="(xx) xxxxx-xxxx"
                        />
                    </div>


                    {/* PERFIL (ROLE) */}
                    <div>
                        <label htmlFor="role" className="block text-sm font-medium text-gray-700">Perfil (Role)</label>
                        <select
                            id="role"
                            required
                            className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2"
                            value={role}
                            onChange={(e) => setRole(e.target.value)}
                        >
                            {availableRoles.map((r) => (
                                <option key={r} value={r}>{r.toUpperCase()}</option>
                            ))}
                        </select>
                    </div>

                    {/* SENHA */}
                    <div>
                        <label htmlFor="senha" className="block text-sm font-medium text-gray-700">
                            {isEditing ? 'Senha (Deixe vazio para manter a atual)' : 'Senha (mínimo 8 caracteres)'}
                        </label>
                        <input
                            id="senha"
                            type="password"
                            required={!isEditing}
                            className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2"
                            value={senha}
                            onChange={(e) => setSenha(e.target.value)}
                            placeholder={isEditing ? 'Deixe vazio para manter' : 'Digite a senha'}
                        />
                    </div>

                    <footer className="pt-4 flex justify-end space-x-3">
                        <button
                            type="button"
                            onClick={onClose}
                            className="py-2 px-4 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 hover:bg-gray-50 transition-colors"
                        >
                            Cancelar
                        </button>
                        <button
                            type="submit"
                            disabled={loading}
                            className={`py-2 px-4 rounded-md shadow-sm text-sm font-medium text-white transition-colors ${loading ? 'bg-teal-400' : 'bg-teal-600 hover:bg-teal-700'}`}
                        >
                            {loading ? 'Salvando...' : (isEditing ? 'Salvar Alterações' : 'Criar Usuário')}
                        </button>
                    </footer>
                </form>
            </div>
        </div>
    );
};

export default UserModal;